"use strict";
exports.__esModule = true;
exports.propValueToDefault = exports.isOption = exports.isOptionSet = exports.isUOptionSet = void 0;
exports.isUOptionSet = function (value) {
    return 'uuid' in value;
};
exports.isOptionSet = function (value) { return 'id' in value; };
exports.isOption = function (value) {
    if (!value) {
        return false;
    }
    if ('name' in value && ('uuid' in value || 'id' in value)) {
        return true;
    }
    return false;
};
exports.propValueToDefault = function (name, options, data) {
    if (!data) {
        return '';
    }
    var v = data[name];
    if (typeof v === 'number' || typeof v === 'string') {
        return v;
    }
    if (exports.isOption(v)) {
        var a = options.find(function (x) {
            if (exports.isUOptionSet(x) && exports.isUOptionSet(v)) {
                return x.uuid === v.uuid;
            }
            else if (exports.isOptionSet(x) && exports.isOptionSet(v)) {
                return x.id === v.id;
            }
        });
        if (a) {
            if (exports.isUOptionSet(a)) {
                return a.uuid;
            }
            return a.id;
        }
    }
    return '';
};
